import { render, staticRenderFns } from "./DialogoExibirEntradas.vue?vue&type=template&id=8a81284c&scoped=true&"
import script from "./DialogoExibirEntradas.vue?vue&type=script&lang=js&"
export * from "./DialogoExibirEntradas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a81284c",
  null
  
)

export default component.exports